<template>
  <v-snackbar
    v-model="isVisible"
    :timeout="timeout"
    :bottom="y"
    :color="color"
  >
    <v-row align="center">
      <v-col v-if="parseHtml" v-html="text">
      </v-col>
      <v-col v-else>
        {{ text }}
      </v-col>
      <v-col cols="auto">
        <EsButtonIcon @click="closeNow()" icon="mdi-close" />
      </v-col>
    </v-row>
  </v-snackbar>
</template>

<script>
import EsButtonIcon from "../buttons/EsButtonIcon.vue";

let defaultTimeout = 5000;
export default {
  name: 'EsSnackbar',
  components: {
    EsButtonIcon,
  },
  props: {
    color: {
      type: String,
      default: '#44acc0'
    },
    text: {
      type: [String, Array],
    },
    parseHtml: {
      type: Boolean,
      default: false,
    },
    visible: {
      type: Boolean,
      default: false,
    },
  },
  data: () => ({
    y: 'bottom',
    timeout: defaultTimeout,
  }),
  computed: {
    isVisible: {
      get() {
        return this.visible;
      },
      set() {
        this.$emit('reset');
        this.timeout = defaultTimeout;
      }
    }
  },
  methods: {
    closeNow() {
      this.timeout = 1;
    }
  }
};
</script>

<style>
.v-snack__wrapper a {
  color: rgba(255, 255, 255, 0.7) !important;
}
</style>
